import { useContext } from "react";

import SubscriptionFormContext from "./SubscriptionFormContext";
import { resolveVariantSelection } from "./cartApi";

interface CartAPIFormProps {
  isSubscribing: boolean;
  sellingPlanId: string;
  isSubscribingToRefills: boolean;
  quantity: number;
}

// Keeps the surrounding Liquid <form>'s hidden fields in sync so Shopify's
// dynamic checkout / Shop Pay button (rendered outside this island) reflects
// the selected purchase option. The main "Add to cart" button does not submit
// this form; see BuyButton.tsx / cartApi.ts.
export default function CartAPIForm({
  isSubscribing,
  sellingPlanId,
  isSubscribingToRefills,
  quantity,
}: CartAPIFormProps) {
  const { productIds } = useContext(SubscriptionFormContext);
  const { id, sellingPlan } = resolveVariantSelection({
    isSubscribing,
    isSubscribingToRefills,
    sellingPlanId,
    productIds,
  });

  return (
    <>
      <input type="hidden" name="id" value={id} />
      {sellingPlan && <input type="hidden" name="selling_plan" value={sellingPlan} />}
      <input type="hidden" name="quantity" value={quantity} />
    </>
  );
}
